import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { class: "filter-box" }
const _hoisted_12 = { class: "filter-box" }
const _hoisted_13 = { class: "filter-box" }
const _hoisted_14 = { class: "filter-box" }
const _hoisted_15 = { class: "filter-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TableList = _resolveComponent("TableList")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "label" }, "业务名称", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.listQuery.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.name) = $event)),
            style: {"width":"200px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item",
            clearable: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, null, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "label" }, "品牌", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.listQuery.brand,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.brand) = $event)),
            style: {"width":"200px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item",
            clearable: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, null, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "型号", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.listQuery.model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.model) = $event)),
            style: {"width":"200px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item",
            clearable: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, null, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "序列号", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.listQuery.serial,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.serial) = $event)),
            style: {"width":"200px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item",
            clearable: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, null, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "业务类型", -1)),
          _createVNode(_component_el_select, {
            filterable: true,
            modelValue: _ctx.listQuery.type,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.type) = $event)),
            class: "filter-item",
            placeholder: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"]),
            clearable: "",
            size: _ctx.t('table.btnSize')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessTypeOption, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.mark,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onKeyup", "size"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "紧急程度", -1)),
          _createVNode(_component_el_select, {
            filterable: true,
            modelValue: _ctx.listQuery.urgentId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.urgentId) = $event)),
            class: "filter-item",
            placeholder: "",
            clearable: "",
            size: _ctx.t('table.btnSize'),
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.urgentOption, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.mark,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "客户公司", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.listQuery.customerCompanyName,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.customerCompanyName) = $event)),
            style: {"width":"200px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item",
            clearable: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, null, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "客户联系人", -1)),
          _createVNode(_component_el_input, {
            modelValue: _ctx.listQuery.customerCompanyContactName,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.customerCompanyContactName) = $event)),
            style: {"width":"200px"},
            size: _ctx.t('table.btnSize'),
            class: "filter-item",
            clearable: "",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, null, 8, ["modelValue", "size", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "业务员", -1)),
          _createVNode(_component_el_select, {
            filterable: true,
            modelValue: _ctx.listQuery.salesManId,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.listQuery.salesManId) = $event)),
            class: "filter-item",
            placeholder: "",
            remote: "",
            clearable: "",
            size: _ctx.t('table.btnSize'),
            onFocus: _ctx.handleSalesManFocus,
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesManOption, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.mark,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "size", "onFocus", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "工程师", -1)),
          _createVNode(_component_el_select, {
            filterable: true,
            modelValue: _ctx.listQuery.engineerId,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.listQuery.engineerId) = $event)),
            class: "filter-item",
            placeholder: "",
            remote: "",
            clearable: "",
            size: _ctx.t('table.btnSize'),
            onFocus: _ctx.handleEngineerFocus,
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.engineerOption, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.mark,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "size", "onFocus", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "开始日期", -1)),
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.listQuery.startTime,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
            type: "date",
            placeholder: " ",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"]),
            size: _ctx.t('table.btnSize')
          }, null, 8, ["modelValue", "onKeyup", "size"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.listQuery.endTime,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
            type: "date",
            placeholder: " ",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            onKeyup: _withKeys(_ctx.handleFilter, ["enter"]),
            size: _ctx.t('table.btnSize')
          }, null, 8, ["modelValue", "onKeyup", "size"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleCommand('add')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ])
        ])
      ]),
      _withDirectives(_createVNode(_component_TableList, {
        dataList: _ctx.list,
        total: _ctx.total,
        columnAllData: _ctx.columnAllData,
        page: _ctx.listQuery.page,
        size: _ctx.listQuery.size,
        tableName: _ctx.TableName,
        showSelection: true,
        permissionName: _ctx.permissionName,
        canCommand: false,
        canChangeColumn: false,
        onCommandChange: _ctx.handleCommand
      }, null, 8, ["dataList", "total", "columnAllData", "page", "size", "tableName", "permissionName", "onCommandChange"]), [
        [_directive_loading, _ctx.listLoading]
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible && !_ctx.quotationVisible]
    ])
  ]))
}